export function normalizeUserStatus(raw, fallback = "active") {
  const value = String(raw ?? fallback).trim().toLowerCase();
  if (value === "active") return "active";
  if (value === "on hold" || value === "onhold" || value === "hold") return "on hold";
  if (value === "finished") return "finished";
  if (value === "rejected") return "rejected";
  if (value === "quit" || value === "quitted") return "quit";
  if (value === "disabled") return "disabled";
  if (value === "blocked") return "blocked";
  if (value === "inactive") return "inactive";
  if (value === "terminated") return "terminated";
  return fallback;
}

export function statusLabelFromRaw(raw) {
  const normalized = normalizeUserStatus(raw);
  if (normalized === "on hold") return "On Hold";
  if (normalized === "finished") return "Finished";
  if (normalized === "rejected") return "Rejected";
  if (normalized === "quit") return "Quit";
  if (normalized === "disabled") return "Disabled";
  if (normalized === "blocked") return "Blocked";
  if (normalized === "inactive") return "Inactive";
  if (normalized === "terminated") return "Terminated";
  return "Active";
}

export function isRejectedStatus(raw) {
  return normalizeUserStatus(raw) === "rejected";
}

export function isAccountBlockedStatus(raw) {
  const normalized = normalizeUserStatus(raw);
  return (
    normalized === "finished" ||
    normalized === "rejected" ||
    normalized === "quit" ||
    normalized === "disabled" ||
    normalized === "blocked" ||
    normalized === "inactive" ||
    normalized === "terminated"
  );
}
